import React from 'react';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import { Box } from '@material-ui/core';
import { useSelector } from 'react-redux';
import { Store } from 'redux/store';
import { returnTitle } from 'constants/helper';
import useQuery from 'hooks/useQuery';
import { useHistory, useParams } from 'react-router-dom';
import { getSessionStorage } from 'utility/browserStorageUtil';
import useStyles from './styles';

const POS_TITLE = [{ text: 'レジ', value: '0' },
  { text: '返品', value: '1' },
  // { text: '両替', value: '2' },
  { text: '精算', value: '3' },
  { text: '閉店処理', value: '4' },
];

const FACIAL_TITLE = [
  { text: 'フェイシャル登録', value: 'FACE' },
  { text: 'ボディ登録', value: 'BODY' },
  { text: 'ボディスキン登録', value: 'BODY_SKIN' },
];

const APPLICATION_ROUTE_TITLE = [
  { text: '申請ルート登録', value: '0' }, // Add
  { text: '申請ルート編集', value: '1' }, // Update
];

const APPLICATION_APPROVER_SETTING_TITLE = [
  { text: '申請ルート承認者設定', value: 'APPROVER_SETTING' }, // Setting
];

type AppBarType = {
  title: string
}
function Appbar({ title }: AppBarType) {
  const companyCode = getSessionStorage('companyCode');
  const URLSearchParams = useQuery();
  const { type } = useParams<any>();
  // For Pos Tab Tittle
  const tabNow = URLSearchParams.get('tab') || '';
  const target = POS_TITLE.find((item) => item?.value === tabNow);

  // For Facial Tab Tittle
  const tabCate = URLSearchParams.get('cate') || '';
  const targetFacial = FACIAL_TITLE.find((item) => item?.value === tabCate);

  // For route Tab Tittle
  const tabRoute = URLSearchParams.get('typeRoute') || '0';
  const targetRoute = APPLICATION_ROUTE_TITLE.find((item) => item?.value === tabRoute);

  const history = useHistory();
  const { location: { pathname } } = history;
  const classes = useStyles();
  const { orgname } = useSelector((reduxState: Store) => reduxState.ui);
  const titleApp = returnTitle(title, orgname.orgName);// hien thi store theo orgName
  // eslint-disable-next-line no-nested-ternary
  const getTitle = () => {
    if (tabNow !== '' && pathname === `/${companyCode}/pos`) {
      return (target?.text || '');
    }
    if (tabNow === '' && tabCate !== '') {
      return (targetFacial?.text || '');
    }
    if (tabRoute === '1') {
      return (targetRoute?.text || '');
    }
    if (type === 'approverSetting') {
      return APPLICATION_APPROVER_SETTING_TITLE.find((item) => item?.value === 'APPROVER_SETTING')?.text || '';
    }
    return '';
  };
  const titleNew = getTitle();
  return (
    <AppBar className={classes.root} position="absolute">
      { title !== '' && (
      <Toolbar className={classes.toolbar}>
        <Box>
          <Typography className={classes.text} variant="h5" variantMapping={{ h5: 'h1' }}>
            {titleNew !== '' ? titleNew : titleApp}
          </Typography>
        </Box>
      </Toolbar>
      )}
    </AppBar>
  );
}

export default Appbar;
